import AjaxUtils from '../../util/ajax_utils';
import Vue from 'vue';
import { ApckTrustScanStatusColumn } from '../trust/trust_columns';

export const ApckAdminTrustScans = {
    data: function () {
        return {
            activeTab: 'running',
            search: '',
            appliedSearch: '',
            statusFilter: '',
            pollTimer: null,
            runningCount: 0,
            pendingCount: 0,
            runningCols: [
                { data: 'organisation', heading: 'Organisation', width: 220 },
                { data: 'status', heading: 'Status', ctype: 'trust-scan-status', width: 120 },
                { data: 'started_at', heading: 'Started', ctype: 'datecolumn', width: 160 },
                { data: 'last_update_at', heading: 'Last Update', ctype: 'datecolumn', width: 160 },
                { data: 'duration', heading: 'Duration', width: 120 },
                { data: 'triggered_by', heading: 'Triggered By', width: 140 },
            ],
            pendingCols: [
                { data: 'organisation', heading: 'Organisation', width: 220 },
                { data: 'status', heading: 'Status', ctype: 'trust-scan-status', width: 120 },
                { data: 'source', heading: 'Source', width: 120 },
                { data: 'next_scan_at', heading: 'Projected Run', ctype: 'datecolumn', width: 160 },
                { data: 'scan_repeat_interval', heading: 'Repeat Interval', width: 140 },
                { data: 'triggered_by', heading: 'Triggered By', width: 140 },
            ],
            statusOptions: [
                { value: '', label: 'All Statuses' },
                { value: 'running', label: 'Running' },
                { value: 'initializing', label: 'Initializing' },
                { value: 'queued', label: 'Queued' },
                { value: 'pending', label: 'Pending' },
                { value: 'aborting', label: 'Aborting' },
            ],
        }
    },
    computed: {
        runningSrc: function () {
            var params = [];
            if (this.statusFilter) params.push('status=' + encodeURIComponent(this.statusFilter));
            if (this.appliedSearch) params.push('search=' + encodeURIComponent(this.appliedSearch));
            return '/admin/trust_scans/running' + (params.length ? '?' + params.join('&') : '');
        },
        pendingSrc: function () {
            var params = [];
            if (this.appliedSearch) params.push('search=' + encodeURIComponent(this.appliedSearch));
            return '/admin/trust_scans/pending' + (params.length ? '?' + params.join('&') : '');
        },
    },
    methods: {
        switchTab: function (tab) {
            this.activeTab = tab;
            this.search = '';
            this.appliedSearch = '';
            this.statusFilter = '';
        },
        refresh: function () {
            this.fetchCounts();
            var cmp = this;
            this.$nextTick(function () {
                if (cmp.activeTab === 'running' && cmp.$refs.runningTable) {
                    cmp.$refs.runningTable.store.load();
                } else if (cmp.activeTab === 'pending' && cmp.$refs.pendingTable) {
                    cmp.$refs.pendingTable.store.load();
                }
            });
        },
        fetchCounts: function () {
            var cmp = this;
            AjaxUtils.ajax_get({
                url: '/admin/trust_scans/counts',
                success: function (data) {
                    if (data && data.success) {
                        cmp.runningCount = data.running || 0;
                        cmp.pendingCount = data.pending || 0;
                    }
                },
                fail: function () {},
                opts: {
                    dataType: 'json',
                    flash_form_errors: false,
                    show_success_flash: false,
                    flash_404_errors: false,
                }
            });
        },
        onSearchInput: function () {
            var cmp = this;
            if (cmp._searchTimer) clearTimeout(cmp._searchTimer);
            cmp._searchTimer = setTimeout(function () {
                cmp.appliedSearch = cmp.search;
            }, 400);
        },
    },
    created: function () {
        Vue.component('apck-trust-scan-status', ApckTrustScanStatusColumn);
    },
    mounted: function () {
        var cmp = this;
        cmp.fetchCounts();
        cmp.pollTimer = setInterval(function () {
            cmp.refresh();
        }, 15000);
    },
    beforeDestroy: function () {
        if (this.pollTimer) {
            clearInterval(this.pollTimer);
            this.pollTimer = null;
        }
    },
    template: `
        <ui-page title="Trust Scans" stickyTitle>
            <template #title-bar-buttons>
                <ui-button
                    label="Refresh"
                    iconLeft="fa-refresh"
                    type="outline"
                    @click.prevent="refresh"
                />
            </template>
            <template #content>
                <ui-layout direction="column" gap="0">
                    <ui-layout direction="row" gap="0" align="end">
                        <ui-button
                            :label="'Running (' + runningCount + ')'"
                            :type="activeTab === 'running' ? 'primary' : 'outline'"
                            tab
                            @click.prevent="switchTab('running')"
                        />
                        <ui-button
                            :label="'Pending (' + pendingCount + ')'"
                            :type="activeTab === 'pending' ? 'primary' : 'outline'"
                            tab
                            @click.prevent="switchTab('pending')"
                        />
                    </ui-layout>

                    <ui-panel-base
                        direction="column"
                        justify="start"
                        align="stretch"
                        gap="2"
                        class="panel-box--tab-content"
                    >
                        <ui-layout class="filter-bar" align="center">
                            <ui-input-text
                                class="search-input"
                                placeholder="Search by organisation name..."
                                :modelValue="search"
                                @update:modelValue="search = $event; onSearchInput()"
                                iconLeft="fa-search"
                            />
                            <apck-select
                                v-if="activeTab === 'running'"
                                v-model="statusFilter"
                                :options="statusOptions"
                                label="Status"
                                style="min-width: 180px;"
                            />
                        </ui-layout>

                        <apck-panel
                            v-if="activeTab === 'running'"
                            title="Running Trust Scans"
                            icon="fa-spinner"
                            no-padding
                            class="trust-data-panel"
                        >
                            <apck-table
                                ref="runningTable"
                                :columns="runningCols"
                                :src="runningSrc"
                                :limit="50"
                                :border="false"
                                :show-toolbar="false"
                                newStyleTable
                            />
                        </apck-panel>

                        <apck-panel
                            v-if="activeTab === 'pending'"
                            title="Pending & Projected Trust Scans"
                            icon="fa-clock"
                            no-padding
                            class="trust-data-panel"
                        >
                            <apck-table
                                ref="pendingTable"
                                :columns="pendingCols"
                                :src="pendingSrc"
                                :limit="50"
                                :border="false"
                                :show-toolbar="false"
                                newStyleTable
                            />
                        </apck-panel>
                    </ui-panel-base>
                </ui-layout>
            </template>
        </ui-page>
    `
};
